var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGranted('CREATE_PRICE_LEVEL'))?_c('q-btn',{attrs:{"label":"Add Price Level","icon":"fa fa-plus","color":"primary"},on:{"click":_vm.openModal}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }